export enum RequestStrategyEnum {
  Default = 'default',
  Debounce = 'debounce',
  Abort = 'abort',
}
